export default __webpack_public_path__ + "static/media/steel_fabrication.9612e812.jpg";